export default "__VITE_ASSET__zwiB3r5s__"